/* rhoneprints: soft generated ambience (slow pads + the odd chime). follows the sound on/off button. starts once sound turns on (first click, tap or key press). */
(function () {
  'use strict';
  var AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return;
  var ctx = null, master = null, bus = null, playing = false, chordT = null, sparkT = null;
  var LEVEL = 0.05;
  var CHORDS = [
    [110, 164.81, 261.63, 392.0, 493.88],
    [87.31, 130.81, 220.0, 329.63, 440.0],
    [98.0, 146.83, 246.94, 392.0, 587.33],
    [82.41, 123.47, 196.0, 293.66, 369.99]
  ];
  var SPARK = [784, 880, 1046.5, 1318.5, 1568];
  var ci = 0;
  function wanted() { return !!(window.glSoundOn && window.glSoundOn()); }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function build() {
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
    var lp = ctx.createBiquadFilter();
    lp.type = 'lowpass'; lp.frequency.value = 950; lp.Q.value = 0.4;
    var lfo = ctx.createOscillator(), lg = ctx.createGain();
    lfo.frequency.value = 0.05; lg.gain.value = 300;
    lfo.connect(lg); lg.connect(lp.frequency); lfo.start();
    var dly = ctx.createDelay(1.5); dly.delayTime.value = 0.47;
    var fb = ctx.createGain(); fb.gain.value = 0.42;
    var wet = ctx.createGain(); wet.gain.value = 0.5;
    bus = ctx.createGain();
    bus.connect(lp);
    lp.connect(master);
    lp.connect(dly); dly.connect(fb); fb.connect(dly); dly.connect(wet); wet.connect(master);
  }
  function note(f, dur, peak, type) {
    var t = ctx.currentTime;
    var o = ctx.createOscillator(), g = ctx.createGain();
    o.type = type; o.frequency.value = f; o.detune.value = rnd(-6, 6);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.linearRampToValueAtTime(peak, t + dur * 0.35);
    g.gain.linearRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(bus);
    o.start(t); o.stop(t + dur + 0.1);
  }
  function chord() {
    if (!playing) return;
    var ch = CHORDS[ci++ % CHORDS.length];
    ch.forEach(function (f, i) { note(f, 15, 0.16 / (1 + i * 0.35), i % 2 ? 'triangle' : 'sine'); });
    chordT = setTimeout(chord, 11000);
  }
  function spark() {
    if (!playing) return;
    if (!document.hidden) {
      var f = SPARK[Math.floor(Math.random() * SPARK.length)];
      var t = ctx.currentTime;
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine'; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(0.05, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 2.6);
      o.connect(g); g.connect(bus);
      o.start(t); o.stop(t + 2.7);
    }
    sparkT = setTimeout(spark, rnd(5000, 12000));
  }
  function start() {
    if (playing) return;
    if (!ctx) build();
    if (ctx.state !== 'running' && ctx.state !== 'closed') ctx.resume();
    playing = true;
    var t = ctx.currentTime;
    master.gain.cancelScheduledValues(t);
    master.gain.setValueAtTime(master.gain.value, t);
    master.gain.linearRampToValueAtTime(LEVEL, t + 4);
    chord();
    sparkT = setTimeout(spark, 3000);
  }
  function stop() {
    if (!playing) return;
    playing = false;
    clearTimeout(chordT); clearTimeout(sparkT);
    var t = ctx.currentTime;
    master.gain.cancelScheduledValues(t);
    master.gain.setValueAtTime(master.gain.value, t);
    master.gain.linearRampToValueAtTime(0, t + 0.8);
    setTimeout(function () { if (!playing && ctx) ctx.suspend(); }, 1000);
  }
  function sync() { if (wanted()) start(); else stop(); }

  /* the sound buttons turn it on or off */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.gl-sound, [data-gl-sound]')) setTimeout(sync, 0);
  }, true);
  /* any tap, click or key press while sound is on: start the ambience, or wake the audio if the phone put it to sleep.
     (phones only allow audio to start from a real touch, and can suspend it again, so this keeps trying) */
  function gesture(e) {
    var tg = e && e.target && e.target.closest ? e.target : null;
    if (tg && tg.closest('.gl-sound, [data-gl-sound]')) return;
    if (!wanted()) return;
    if (!playing) start();
    else if (ctx && ctx.state !== 'running' && ctx.state !== 'closed') ctx.resume();
  }
  ['pointerdown', 'pointerup', 'touchstart', 'touchend', 'click', 'keydown'].forEach(function (t) { document.addEventListener(t, gesture, true); });
})();